<template>
    <v-container>
        <!-- Banner promocional (grupo por cantidad y/o forma de pago) -->
        <promo-banner :grupo-id="grupoIdProductos"></promo-banner>

        <v-row class="mt-4" v-if="loading">
            <v-col v-for="i in 3" cols="6" :key="`${i}ab`">
                <v-skeleton-loader type="card" :loading="loading">
                </v-skeleton-loader>
            </v-col>
        </v-row>
        <v-row class="mt-1 product-list-flat" dense v-else-if="products.length">
            <v-col v-for="(p, i) in products" :key="i" cols="12" class="py-0">
                <product-mobile-card :product="p" :categoria-disponible="categoriaDisponible"></product-mobile-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import ProductMobileCard from '../cards/ProductMobileCard.vue'
import PromoBanner from '../PromoBanner.vue'

export default {
  components: { ProductMobileCard, PromoBanner },
  name: 'ProductosListMobile',
  computed: {
    ...mapState('Categorias', ['currentCategoria']),
    ...mapState('App', ['tiendaActual']),
    categoriaDisponible () {
      if (!this.categoria) return true
      return this.$store.getters['Categorias/categoriaDisponible'](this.categoria)
    },
    grupoIdProductos () {
      if (this.products && this.products.length > 0) {
        const productoConGrupo = this.products.find(p => p.GrupoDescuento && p.GrupoDescuento.GrupoId)
        return productoConGrupo ? productoConGrupo.GrupoDescuento.GrupoId : null
      }
      return null
    }
  },
  methods: {
    ...mapActions('Productos', ['fetchProducts']),
    emitLoaded () {
      this.$emit('products-loaded', (this.products && this.products.length) || 0)
    }
  },
  props: {
    categoriaId: {
      type: Number,
      default: null
    },
    categoria: {
      type: Object,
      default: null
    },
    mesaId: {
      type: Number,
      default: null
    }
  },
  watch: {
    '$route.params.client': {
      handler: async function (newClient, oldClient) {
        if (newClient && newClient !== oldClient && this.categoriaId) {
          this.loading = true
          this.products = await this.fetchProducts(this.categoriaId)
          this.loading = false
          this.emitLoaded()
        }
      },
      immediate: false
    },
    categoriaId: {
      handler: async function (newId, oldId) {
        if (newId && newId !== oldId) {
          this.loading = true
          this.products = await this.fetchProducts(newId)
          this.loading = false
          this.emitLoaded()
        }
      },
      immediate: false
    }
  },
  data () {
    return {
      loading: false,
      products: [],
      previousPage: null
    }
  },
  async mounted () {
    this.loading = true
    this.products = await this.fetchProducts(
      this.categoriaId
    )
    this.loading = false
    this.emitLoaded()
  }
}
</script>
